import { createFileRoute, redirect } from '@tanstack/react-router'
import { RulesListScreen } from '@/features/accounting-bank/rules-list-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/bank-rules')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bank_rule.view')) throw redirect({ to: '/' })
  },
  component: RulesListScreen,
})
